"use client";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Image from "next/image";
import parse from "html-react-parser";
import SliderArrow from "@/components/SliderArrow";
import { IPageContent } from "@/types/pageContent.types";
import "./Scene11CardsSliderV15.scss";

type Scene11CardsSliderV15Props = {
  imgsData: IPageContent["ionTrackingDevicePageModel"]["ionTrackingDevicePage"]["ionTrackingDeviceAppliedAcrossComplex"];
};

export default function Scene11CardsSliderV15({
  imgsData,
}: Scene11CardsSliderV15Props) {
  const renderBodyWithMarkdownLinks = (body: string) =>
    body.replace(
      /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
      '<a href="$2">$1</a>'
    );

  let arrows: { url: string; alt: string }[] = [];
  if (Array.isArray(imgsData) && imgsData.length > 0) {
    const lastItem = imgsData[imgsData.length - 1];
    if (
      lastItem.__typename === "GalleryRecord" &&
      Array.isArray(lastItem.gallery) &&
      lastItem.gallery.length >= 1
    ) {
      arrows = lastItem.gallery;
    }
  }

  const sliderCards = imgsData.filter(
    (
      card
    ): card is Extract<
      Scene11CardsSliderV15Props["imgsData"][number],
      { __typename: "BodyGalleryRecord" }
    > => card.__typename === "BodyGalleryRecord"
  );

  const sectionHeading =
    imgsData.find((item) => item.__typename === "HeadingRecord")?.heading ??
    imgsData.find(
      (item): item is Extract<
        Scene11CardsSliderV15Props["imgsData"][number],
        { __typename: "OverlineHeadingBodyGalleryRecord" }
      > => item.__typename === "OverlineHeadingBodyGalleryRecord"
    )?.heading ??
    "Explore how ION is applied across different environments";

  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "0px",
    slidesToShow: 3,
    speed: 500,
    nextArrow: (
      <SliderArrow
        direction="next"
        imageUrl={arrows[arrows.length > 1 ? 1 : 0]?.url}
        imageAlt={arrows[arrows.length > 1 ? 1 : 0]?.alt}
      />
    ),
    prevArrow: (
      <SliderArrow
        direction="prev"
        imageUrl={arrows[0]?.url}
        imageAlt={arrows[0]?.alt}
        rotatePrev={arrows.length === 1}
      />
    ),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerPadding: "0px",
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      // {
      //   breakpoint: 480,
      //   settings: {
      //     centerPadding: "0px",
      //     slidesToShow: 1,
      //     slidesToScroll: 1,
      //     infinite: true,
      //     dots: true,
      //   },
      // },
    ],
  };


  return (
    <div className="scene11CardsSliderV15">
      <h3>{sectionHeading}</h3>
      <Slider {...settings}>
        {sliderCards.map((card, index) => (
          <div key={index} className="card">
            {card.gallery.length > 0 ? (
              <Image
                src={card.gallery[0].url}
                alt={card.gallery[0].alt}
                fill
                style={{ objectFit: "cover" }}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              />
            ) : null}
            <p>{parse(renderBodyWithMarkdownLinks(card.body))}</p>
          </div>
        ))}
      </Slider>
    </div>
  );
}
